import { gql } from '__generated__'

export const GetAddEditRosterOptions = gql(/* GraphQL */ `
    query GetAddEditRosterOptions {
        processStatuses {
            id
            status
            statusLabel
            processStatusSummaryGroup {
                id
                summaryGroup
                label
            }
        }
        industries {
            id
            value
        }
        sectors {
            id
            value
        }
        titles {
            id
            value
        }
        rosterStartDates
        visaStatuses {
            id
            value
        }
    }
`)

export const GetCompanySpecificOptions = gql(/* GraphQL */ `
    query GetCompanySpecificOptions($companyId: ID!) {
        company(id: $companyId) {
            employees {
                id
                user {
                    nickname
                    lastName
                    firstName
                }
            }
            companyOffices {
                id
                officeLocation {
                    value
                    id
                }
            }
        }
    }
`)

export const GetRosterData = gql(/* GraphQL */ `
    query GetRosterData($rosterId: ID!) {
        roster(id: $rosterId) {
            id
            rosterName
            rosterType
            permissions {
                canView
                canEdit
            }
            mapping {
                id
                filter
            }
            clientContacts {
                candidate {
                    id
                    user {
                        firstName
                        nickname
                        lastName
                        id
                    }
                }
            }
            company {
                id
                value
            }
            companyOffices {
                companyOffice {
                    id
                    officeLocation {
                        id
                        value
                    }
                }
            }
            industries {
                industry {
                    id
                    value
                }
            }
            sectors {
                sector {
                    id
                    value
                }
            }
            sharedRecruiters {
                recruiterId
                recruiter {
                    id
                    userId
                    user {
                        firstName
                        lastName
                        nickname
                    }
                }
            }
            status
            consultants
            visaStatuses {
                visaStatus {
                    id
                    value
                }
            }
            startDateLabel
            placements {
                title {
                    id
                    value
                }
                placementCount
            }
        }
    }
`)

export const EditRoster = gql(/* GraphQL */ `
    mutation EditRoster(
        $rosterId: ID!
        $rosterName: String
        $companyId: ID
        $clientContactIds: [ID!]
        $companyOfficeIds: [ID!]
        $positions: [RosterPlacementInput!]
        $sectorIds: [ID!]
        $industryIds: [ID!]
        $sharedRecruiterIds: [ID!]
        $rosterStatus: RosterStatus
        $startDate: String
        $consultants: Boolean
        $visaStatusIds: [ID!]
        $mappingFilter: CandidateFilterStateInput
    ) {
        updateRoster(
            rosterId: $rosterId
            rosterName: $rosterName
            companyId: $companyId
            clientContactIds: $clientContactIds
            companyOfficeIds: $companyOfficeIds
            positions: $positions
            sectorIds: $sectorIds
            industryIds: $industryIds
            sharedRecruiterIds: $sharedRecruiterIds
            rosterStatus: $rosterStatus
            startDate: $startDate
            consultants: $consultants
            visaStatusIds: $visaStatusIds
            mappingFilter: $mappingFilter
        ) {
            success
            message
        }
    }
`)

export const CreateRoster = gql(/* GraphQL */ `
    mutation CreateRoster(
        $rosterName: String!
        $rosterType: RosterType!
        $candidateIds: [ID!]!
        $companyId: ID
        $companyOfficeIds: [ID!]
        $industryIds: [ID!]
        $initialCandidateProcessStatusId: ID
        $clientContactIds: [ID!]
        $positions: [RosterPlacementInput!]
        $rosterStatus: RosterStatus!
        $sectorIds: [ID!]
        $sharedRecruiterIds: [ID!]
        $startDate: String
        $mappingFilter: CandidateFilterStateInput
    ) {
        addRoster(
            rosterName: $rosterName
            rosterType: $rosterType
            candidateIds: $candidateIds
            companyId: $companyId
            companyOfficeIds: $companyOfficeIds
            industryIds: $industryIds
            clientContactIds: $clientContactIds
            positions: $positions
            rosterStatus: $rosterStatus
            sectorIds: $sectorIds
            sharedRecruiterIds: $sharedRecruiterIds
            initialCandidateProcessStatusId: $initialCandidateProcessStatusId
            startDate: $startDate
            mappingFilter: $mappingFilter
        ) {
            id
        }
    }
`)
